import { gql } from "graphql-tag"

const DELETE_LABEL = gql`
  mutation deleteLabel($id: ID!) {
    deleteLabel(id: $id) {
      status
    }
  }
`

export default DELETE_LABEL
